import { render, staticRenderFns } from "./Home_Product_Item.vue?vue&type=template&id=fa809a6e&scoped=true&"
import script from "./Home_Product_Item.vue?vue&type=script&lang=js&"
export * from "./Home_Product_Item.vue?vue&type=script&lang=js&"
import style0 from "./Home_Product_Item.vue?vue&type=style&index=0&id=fa809a6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa809a6e",
  null
  
)

export default component.exports